import { StyledRating } from "./rating.styled";
import { ComponentProps } from "./rating.type";

const Rating = ({ handleChange, value }: ComponentProps) => {
  return <StyledRating value={value} size="large" onChange={handleChange} />;
};

export default Rating;
